<template>
  <div class="animated fadeIn form-abm evento-abm">
    <b-row>
      <b-col xl="12">
        <b-card header= "Información del Evento">
          <b-form>
            <app-cliente
              label="Cliente"
              :nombre="clienteNombre"
              :labelCols="labelCols"
              :valido="clienteValido"
              :lista="clientesList"
              :msjInvalido="clienteInvalidoMsj"
              @validate="validate"
              @updated="clienteActualizado">
            </app-cliente>  

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                class="text-upper"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-tipo-evento
              label="Tipo de Evento"
              :nombre="tipoEventoNombre"
              :labelCols="labelCols"
              :valido="tipoEventoValido"
              :lista="tiposEventosList"
              :msjInvalido="tipoEventoInvalidoMsj"
              @validate="validate"
              @updated="tipoEventoActualizado">
            </app-tipo-evento>  

            <b-form-group
              label="Fecha Inicio"
              label-for="fechaInicio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaInicio" 
                v-model="fechaInicio" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Fin"
              label-for="fechaFin"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaFin" 
                v-model="fechaFin" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card v-if="msjTexto || opcionesConfiguracion"
          header= "Opciones de Configuración">
          <b-form>
            <b-form-group
              v-if="msjTexto"
              label="Msj de Texto"
              label-for="mensajeTexto"
              :label-cols="labelCols"
              description="Mensaje a enviar al participante"
              horizontal>
              <b-input-group>
                <b-form-input 
                  id="mensajeTexto"
                  v-model.trim="$v.mensajeTexto.$model" 
                  :state="mensajeTextoValido"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="sendSMS">
                  <b-input-group-text>
                    <i class="fa fa-commenting-o"></i>
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback id="mensajeTextoFeedback">
                {{ mensajeTextoInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              v-if="msjTexto"
              label="Msj de Respuesta"
              label-for="mensajeRespuesta"
              :label-cols="labelCols"
              description="Mensaje para confirmar la participación"
              horizontal>
              <b-form-input 
                id="mensajeRespuesta"
                v-model.trim="$v.mensajeRespuesta.$model" 
                :state="mensajeRespuestaValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="mensajeRespuestaFeedback">
                {{ mensajeRespuestaInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <div v-if="opcionesConfiguracion">
              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="registroManualHabilitado"
                    v-model="registroManualHabilitado"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Registro Manual Habilitado
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaCodigoPromocion"
                    v-model="solicitaCodigoPromocion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Código de Promoción
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereCodigoPromocion"
                    v-model="requiereCodigoPromocion"
                    :disabled="!solicitaCodigoPromocion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Código de Promoción (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="validaCodigoDuplicado"
                    v-model="validaCodigoDuplicado"
                    :disabled="!solicitaCodigoPromocion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida Códigos Duplicados
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaNombre"
                    v-model="solicitaNombre"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Nombre y Apellido
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereNombre"
                    v-model="requiereNombre"
                    :disabled="!solicitaNombre"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Nombre y Apellido (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaDocumento"
                    v-model="solicitaDocumento"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Número de Documento
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereDocumento"
                    v-model="requiereDocumento"
                    :disabled="!solicitaDocumento"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Número de Documento (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="validaDocumentoDuplicado"
                    v-model="validaDocumentoDuplicado"
                    :disabled="!solicitaDocumento"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida Números de Documento Duplicados
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="Fecha de nacimiento, sexo"
                horizontal>
                <b-form-checkbox 
                    id="solicitaDatosPersonales"
                    v-model="solicitaDatosPersonales"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Datos Personales
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="Provincia, localidad, barrio, dirección y cod. postal"
                horizontal>
                <b-form-checkbox 
                    id="solicitaUbicacion"
                    v-model="solicitaUbicacion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Dirección
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereUbicacion"
                    v-model="requiereUbicacion"
                    :disabled="!solicitaUbicacion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Dirección (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaLocalidad"
                    v-model="solicitaLocalidad"
                    :disabled="!solicitaUbicacion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Localidad
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereLocalidad"
                    v-model="requiereLocalidad"
                    :disabled="!solicitaUbicacion || !solicitaLocalidad"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Localidad (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaBarrio"
                    v-model="solicitaBarrio"
                    :disabled="!solicitaUbicacion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Barrio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereBarrio"
                    v-model="requiereBarrio"
                    :disabled="!solicitaUbicacion || !solicitaBarrio"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Barrio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="Código de área y número"
                horizontal>
                <b-form-checkbox 
                    id="solicitaTelefono"
                    v-model="solicitaTelefono"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Nro de Teléfono
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereTelefono"
                    v-model="requiereTelefono"
                    :disabled="!solicitaTelefono"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Nro de Teléfono (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="validaTelefonoDuplicado"
                    v-model="validaTelefonoDuplicado"
                    :disabled="!solicitaTelefono"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida Números de Teléfono Duplicados
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaEmail"
                    v-model="solicitaEmail"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Email
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereEmail"
                    v-model="requiereEmail"
                    :disabled="!solicitaEmail"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Email
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="validaEmailDuplicado"
                    v-model="validaEmailDuplicado"
                    :disabled="!solicitaEmail"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida Emails Duplicados
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="Banco, CBU o CBU Alias, y titular de la cuenta"
                horizontal>
                <b-form-checkbox 
                    id="requiereInformacionBancaria"
                    v-model="requiereInformacionBancaria"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Información Bancaria
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="A través de un titular (dueño, representante, otros)"
                horizontal>
                <b-form-checkbox 
                    id="participacionNegocios"
                    v-model="participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Participación por Negocios
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaPosicionNegocio"
                    v-model="solicitaPosicionNegocio"
                    :disabled="!participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Posición (titular, empleado) del Participante
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requierePosicionNegocio"
                    v-model="requierePosicionNegocio"
                    :disabled="!solicitaPosicionNegocio || !participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Posición del Participante (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaRazonSocialNegocio"
                    v-model="solicitaRazonSocialNegocio"
                    :disabled="!participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Razón Social del Negocio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereRazonSocialNegocio"
                    v-model="requiereRazonSocialNegocio"
                    :disabled="!solicitaRazonSocialNegocio || !participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Razón Social del Negocio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaDocumentoNegocio"
                    v-model="solicitaDocumentoNegocio"
                    :disabled="!participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita CUIT del Negocio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereDocumentoNegocio"
                    v-model="requiereDocumentoNegocio"
                    :disabled="!solicitaDocumentoNegocio || !participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere CUIT del Negocio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="validaDocumentoNegocioDuplicado"
                    v-model="validaDocumentoNegocioDuplicado"
                    :disabled="!solicitaDocumentoNegocio || !participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida CUIT Duplicados
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                description="Provincia, localidad, barrio, dirección y cod. postal"
                horizontal>
                <b-form-checkbox 
                    id="solicitaUbicacionNegocio"
                    v-model="solicitaUbicacionNegocio"
                    :disabled="!participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Dirección del Negocio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereUbicacionNegocio"
                    v-model="requiereUbicacionNegocio"
                    :disabled="!solicitaUbicacionNegocio || !participacionNegocios"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Dirección del Negocio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaLocalidadNegocio"
                    v-model="solicitaLocalidadNegocio"
                    :disabled="!solicitaUbicacionNegocio"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Localidad del Negocio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereLocalidadNegocio"
                    v-model="requiereLocalidadNegocio"
                    :disabled="!solicitaUbicacionNegocio || !solicitaLocalidadNegocio"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Localidad del Negocio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="solicitaBarrioNegocio"
                    v-model="solicitaBarrioNegocio"
                    :disabled="!solicitaUbicacionNegocio"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Solicita Barrio del Negocio
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                horizontal>
                <b-form-checkbox 
                    id="requiereBarrioNegocio"
                    v-model="requiereBarrioNegocio"
                    :disabled="!solicitaUbicacionNegocio || !solicitaBarrioNegocio"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Requiere Barrio del Negocio (Campo obligatorio)
                </b-form-checkbox>
              </b-form-group>

              <br>

              <b-form-group
                :label-cols="labelCols"
                description="Debe validar identidad del participante"
                horizontal>
                <b-form-checkbox 
                    id="validaIdentidad"
                    v-model="validaIdentidad"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Debe Validar Identidad
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                description="Debe validar la participación a traves de fotos, tickets de compra, etc"
                horizontal>
                <b-form-checkbox 
                    id="validaParticipacion"
                    v-model="validaParticipacion"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Debe Validar Participación
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                :label-cols="labelCols"
                description="Permite importar imágenes y/o documentos para la validación (DNI, tickets, etc)"
                horizontal>
                <b-form-checkbox 
                    id="validaImagenes"
                    v-model="validaImagenes"
                    :value="Boolean(true)"
                    :unchecked-value="Boolean(false)">
                    Valida (Identidad/Participación) por Imágenes/Documentos
                </b-form-checkbox>
              </b-form-group>
            </div>

            <b-form-group
              :label-cols="labelCols"
              description="Importa listado de participantes"
              horizontal>
              <b-form-checkbox 
                  id="importaParticipantes"
                  v-model="importaParticipantes"
                  :disabled="importaGanadores"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Importa Participantes
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              description="Importa listado de ganadores (incluye posición)"
              horizontal>
              <b-form-checkbox 
                  id="importaGanadores"
                  v-model="importaGanadores"
                  :disabled="sorteaGanadores || importaParticipantes"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Importa Ganadores
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              description="Habilita sorteo para determinar ganadores"
              horizontal>
              <b-form-checkbox 
                  id="sorteaGanadores"
                  v-model="sorteaGanadores"
                  :disabled="importaGanadores"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Sorteo Ganadores
              </b-form-checkbox>
            </b-form-group>

            <b-form-group
              v-if="opcionesConfiguracion"
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="transferenciasPremios"
                  v-model="transferenciasPremios"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Gestiona Transferencias por Premios
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>

        <b-card v-if="opcionesConfiguracion"
            header= "CamposAdicionales">
          <b-btn class="card-header-add" 
              variant="primary" 
              size="sm"
              @click.prevent="agregarCampoAdicional">
            <i class="fa fa-plus"></i>
          </b-btn>

          <b-table hover
              responsive="sm" 
              class="registro campos-adicionales"
              :busy="tableBusy"
              :items="camposAdicionales" 
              :fields="camposAdicionalesFields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(obligatorio)="data">
              {{ data.item.obligatorio ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(validaDuplicado)="data">
              {{ data.item.validaDuplicado ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(incluirListado)="data">
              {{ data.item.incluirListado ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item
                    @click.stop="editarCampoAdicional(data.item)">
                  <i class="fa fa-edit"></i>Editar Campo Adicional</b-dropdown-item>
                <b-dropdown-item
                    @click.stop="borrarCampoAdicional(data.item)">
                  <i class="fa fa-remove"></i>Borrar Campo Adicional</b-dropdown-item>
              </b-dropdown>
            </template>            
          </b-table>
        </b-card>

        <b-card header= "Columnas" v-if="opcionesConfiguracion">
          <b-table hover
              responsive="sm" 
              class="registro participantes-columnas"
              :items="participantesColumnas" 
              :fields="participantesColumnasFields">
            <template v-slot:cell(orden)="data">
              <template v-if="data.item.seleccionada">
                <input 
                  type="number"
                  v-model="data.item.orden"
                  @focus="$event.target.select()"/>
              </template>
            </template>
            <template v-slot:cell(seleccionada)="data">
              <b-form-checkbox
                  v-model="data.item.seleccionada"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
              </b-form-checkbox> 
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="sendSMSModal" 
        title="Envio de SMS"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-send
        :mensaje="mensajeTexto"
        @close="closeSendSMS">
      </app-send>  
    </b-modal>

    <b-modal ref="campoAdicionalModal" 
        title="Campo Adicional"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-campo-adicional
        :campoAdicional="campoAdicional"
        @close="closeCampoAdicional">
      </app-campo-adicional>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Cliente from '../shared/abmSelect.vue';
import TipoEvento from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import CampoAdicional from './CampoAdicional';
import SendSMS from './SMS';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'evento/getField',
  mutationType: 'evento/updateField',
});

export default {
  name: 'EventoABM',
  components: {
    appCliente: Cliente,
    appTipoEvento: TipoEvento,
    appCampoAdicional: CampoAdicional,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm,
    appSend: SendSMS
  },
  mixins: [ 
    msjModal,
    confirmModal, 
  ],
  data () {
    return {
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      tipoEventoValido: null,
      tipoEventoInvalidoMsj: '',
      mensajeTextoValido: null,
      mensajeTextoInvalidoMsj: '',
      mensajeRespuestaValido: null,
      mensajeRespuestaInvalidoMsj: '',
      // sorteoPuestosValido: null,
      // sorteoPuestosInvalidoMsj: '',

      camposAdicionalesFields: [
        { key: 'campo' },
        { 
          key: 'obligatorio',
          label: 'Requerido',
          class: 'text-center' 
        },
        { 
          key: 'validaDuplicado',
          label: 'Valida Duplicados',
          class: 'text-center' 
        },
        { 
          key: 'incluirListado',
          label: 'Listado Participantes',
          class: 'text-center' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      participantesColumnasFields: [
        { 
          key: 'participanteColumna',
          label: 'Columna'
        },
        { 
          key: 'orden',
        },
        {
          key: 'seleccionada',
          label: '',
          class: 'text-center'
        },
      ],

      clientes: [],
      clientesList: [],
      tiposEventos: [],
      tiposEventosList: [],

      tableBusy: false,
      labelCols: 2,
      loading: false,
      loadingClientes: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'cliente',
      'clienteNombre',
      'nombre',
      'fechaInicio',
      'fechaFin',
      'tipoEvento',
      'tipoEventoNombre',
      'mensajeTexto',
      'mensajeRespuesta',

      'registroManualHabilitado',
      'solicitaCodigoPromocion',
      'requiereCodigoPromocion',
      'validaCodigoDuplicado',
      'solicitaNombre',
      'requiereNombre',
      'solicitaDocumento',
      'requiereDocumento',
      'validaDocumentoDuplicado',
      'solicitaDatosPersonales',
      'solicitaTelefono',
      'requiereTelefono',
      'validaTelefonoDuplicado',
      'solicitaEmail',
      'requiereEmail',
      'validaEmailDuplicado',
      'solicitaUbicacion',
      'requiereUbicacion',
      'solicitaLocalidad',
      'requiereLocalidad',
      'solicitaBarrio',
      'requiereBarrio',
      'requiereInformacionBancaria',
      'participacionNegocios',
      'solicitaPosicionNegocio',
      'requierePosicionNegocio',
      'solicitaRazonSocialNegocio',
      'requiereRazonSocialNegocio',
      'solicitaDocumentoNegocio',
      'requiereDocumentoNegocio',
      'validaDocumentoNegocioDuplicado',
      'solicitaUbicacionNegocio',
      'requiereUbicacionNegocio',
      'solicitaLocalidadNegocio',
      'requiereLocalidadNegocio',
      'solicitaBarrioNegocio',
      'requiereBarrioNegocio',

      'importaParticipantes',
      'sorteaGanadores',
      'importaGanadores',
      'validaIdentidad',
      'validaParticipacion',
      'validaImagenes',
      'transferenciasPremios',

      'camposAdicionales',
      'campoAdicional',
      'participantesColumnas'
      // 'sorteoPuestos',
    ]),
    msjTexto() {
      if (this.tipoEvento) {
        if (this.tipoEvento.id == 1) {
          return true;
        }
      }
      return false;
    },
    opcionesConfiguracion() {
      if (this.tipoEvento) {
        if (this.tipoEvento.id == 2) {
          return true;
        }
      }
      return false;
    },
  },  
  created() {
    let eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        eventoId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.loading = true;
    this.loadingClientes = true;
    this.$store.dispatch('evento/inicializar', eventoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.tiposEventos = [
        {
          id: 1,
          nombre: 'PWA'
        },
        {
          id: 2,
          nombre: 'PORTAL'
        }
      ];
      this.tiposEventosList = [ 'PWA', 'PORTAL' ];
      this.loading = false;

      this.$store.dispatch('clientes/getList')
        .then(() => {
          this.clientes = this.$store.getters['clientes/list']
          this.clientesList = this.$store.getters['clientes/selectList']
          this.loadingClientes = false;
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de clientes')))
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre comercial.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'mensajeTexto' || validarTodos) {
        if (this.$v.mensajeTexto.$error) {
          this.mensajeTextoValido = false;
          if (!this.$v.mensajeTexto.required) {
            this.mensajeTextoInvalidoMsj = 'Debe ingresar el mensaje de texto para el tipo de evento seleccionado';
          } else if (!this.$v.mensajeTexto.maxLength) {
            this.mensajeTextoInvalidoMsj = 'El mensaje de texto solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.mensajeTextoValido = null;
          this.mensajeTextoInvalidoMsj = '';
        }
      }

      if (campo == 'mensajeRespuesta' || validarTodos) {
        if (this.$v.mensajeRespuesta.$error) {
          this.mensajeRespuestaValido = false;
          if (!this.$v.mensajeRespuesta.required) {
            this.mensajeRespuestaInvalidoMsj = 'Debe ingresar el mensaje de respuesta para el tipo de evento seleccionado';
          } else if (!this.$v.mensajeRespuesta.maxLength) {
            this.mensajeRespuestaInvalidoMsj = 'El mensaje de respuesta solo puede contener hasta 255 caracteres';
          } 
        } else {
          this.mensajeRespuestaValido = null;
          this.mensajeRespuestaInvalidoMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      let clienteError = true;
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            clienteError = false;
          }
        }
      }
      if (clienteError) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente.';
        save = false;
      }

      let eventoError = true;
      if (this.tipoEvento) {
        if (this.tipoEvento.id) {
          if (this.tipoEvento.id != 0) {
            eventoError = false;
          }
        }
      }
      if (eventoError) {
        this.tipoEventoValido = false;
        this.tipoEventoInvalidoMsj = 'Debe seleccionar el tipo de evento correspondiente.';
        save = false;
      }

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('evento/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => {
              console.log(error);
              this.showErrorMsj(error);
            })
            .finally(() => this.hideSpinner())
        } 
      }
    },
    setObjeto(objetoNombre, objetoList, objetoDispatch) {
      let objetoSeleccionado = null;
      if (objetoNombre) {
        objetoSeleccionado = this.getSelected(objetoList, objetoNombre);
      }
      
      this.$store.dispatch('evento/' + objetoDispatch, objetoSeleccionado)
        .then(() => {
          return true
        });
      
      return false;
    },
    isObjetoValido(objeto, objetoValido, objetoInvalidoField, objetoInvalidoMsj) {
      let isValido = false;

      let objetoStore = this.$store.getters['evento/' + objeto];

      if (objetoStore) {
        if (objetoStore.id) {
          if (objetoStore.id != 0) {
            isValido = true;
          }
        }
      }

      if (isValido) {
        objetoValido = null;
        objetoInvalidoField = '';
      } else {
        objetoValido = false;
        objetoInvalidoField = objetoInvalidoMsj;
      }
      
      return isValido;
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "Eventos" });
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes) {
        this.clienteNombre = clienteNombre;

        let cliente;
        if (clienteNombre) {
          cliente = this.getSelected(this.clientes, clienteNombre);
        }
        this.$store.dispatch('evento/setCliente', cliente);

        this.clienteValido = null;
        this.clienteInvalidoMsj = '';
      }
    },
    tipoEventoActualizado(tipoEventoNombre) {
      if (!this.loading) {
        this.tipoEventoNombre = tipoEventoNombre;

        let tipoEvento;
        if (tipoEventoNombre) {
          tipoEvento = this.getSelected(this.tiposEventos, tipoEventoNombre);
        }
        this.$store.dispatch('evento/setTipoEvento', tipoEvento);

        this.tipoEventoValido = null;
        this.tipoEventoInvalidoMsj = '';
      }
    },
    sendSMS () {
      if (this.mensajeTexto != '') {
        this.$refs.sendSMSModal.show();
      } else {
        this.showErrorMsj('Debe ingresar un mensaje para probar el envío de SMS.')
      }
      
    },
    closeSendSMS() {
      this.$refs.sendSMSModal.hide();
    },
    agregarCampoAdicional() {
      this.$store.dispatch('evento/seleccionarCampoAdicional')
        .then(() => this.$refs.campoAdicionalModal.show());
    },
    editarCampoAdicional(item) {
      this.$store.dispatch('evento/seleccionarCampoAdicional', item)
        .then(() => this.$refs.campoAdicionalModal.show());
    },
    closeCampoAdicional(campoAdicional) {
      if (campoAdicional) {
        this.$store.dispatch('evento/saveCampoAdicional', campoAdicional);
      }
      this.$refs.campoAdicionalModal.hide();
    },
    borrarCampoAdicional(item) {
      this.showModalConfirm('¿Desea borrar el campo adicional?', 
            this.borrarCampoAdicionalSeleccionado.bind(this, item), 'Si', null, 'No')
    },
    borrarCampoAdicionalSeleccionado(campoAdicional) {
      this.tableBusy = true;
      this.$store.dispatch('evento/deleteCampoAdicional', campoAdicional)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
  },
  watch: {
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(255)
    },
    mensajeTexto: {
      maxLength: maxLength(255),
      required: requiredIf(function () {
        let isRequired = false;

        if (this.tipoEventoNombre) {
          var tipoEvento = this.getSelected(this.tiposEventos, this.tipoEventoNombre);
          if (tipoEvento) {
            if (tipoEvento.id == 1) {
              isRequired = true;
            }
          }
        }
        return isRequired;
      }),
    },
    mensajeRespuesta: {
      maxLength: maxLength(255),
      required: requiredIf(function () {
        let isRequired = false;

        if (this.tipoEventoNombre) {
          var tipoEvento = this.getSelected(this.tiposEventos, this.tipoEventoNombre);
          if (tipoEvento) {
            if (tipoEvento.id == 1) {
              isRequired = true;
            }
          }
        }
        return isRequired;
      }),
    },
    // sorteoPuestos: {
    //   numeric,
    //   minValue: minValue(1)        
    // },
  },  
}
</script>

<style>
  .evento-abm .registro.campos-adicionales table td[aria-colindex="1"] {
    width: calc(55% - 30px);
  }
  .evento-abm .registro.campos-adicionales table td[aria-colindex="2"] {
    width: 15%;
  }
  .evento-abm .registro.campos-adicionales table td[aria-colindex="3"] {
    width: 15%;
  }
  .evento-abm .registro.campos-adicionales table td[aria-colindex="4"] {
    width: 15%;
  }
  .evento-abm .registro.campos-adicionales table td[aria-colindex="5"] {
    width: 30px;
  }


  .evento-abm .registro.participantes-columnas table td[aria-colindex="1"] {
    width: calc(80% - 80px);
  }
  .evento-abm .registro.participantes-columnas table td[aria-colindex="2"] {
    width: 20%;
  }
  .evento-abm .registro.participantes-columnas table td[aria-colindex="3"] {
    width: 80px;
  }

  .evento-abm .registro table td input {
    width: 90%;
    left: 5%;
    margin: 0; 
    text-align: right;
    -moz-appearance:textfield;
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
    font-size: 1em;
  }
  .evento-abm .registro table td input[type=number]::-webkit-inner-spin-button, 
  .evento-abm .registro table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }

</style>
